import produce from 'immer';

// TYPES
import { Types, ExcluirMenus } from './types';
import { ReducerActionRotaSP } from '../../../../../types';

export const INITIAL_STATE: ExcluirMenus = {
	status: 0,
	data: null,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerActionRotaSP,
): ExcluirMenus {
	return produce(state, draft => {
		switch (action.type) {
			case Types.EXCLUIR_MENUS: {
				break;
			}

			case Types.EXCLUIR_MENUS_SUCCESS: {
				draft.data = action.payload.data;
				draft.status = action.payload.status;
				break;
			}

			case Types.EXCLUIR_MENUS_FAILURE: {
				break;
			}

			case Types.EXCLUIR_MENUS_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;

				break;
			}

			default:
		}
	});
}
